<template>
	<v-container>
		<v-breadcrumbs class="py-2" :items="Crumbs()">
			<template v-slot:divider>
				<p class="my-0">
					<v-icon>mdi-chevron-right</v-icon>
				</p>
			</template>
			<template v-slot:item="{ item }">
				<v-breadcrumbs-item
					:class="CrumbsLinkClass"
					:to="item.to"
					:exact="item.exact"
					:disabled="item.disabled"
				>
					<p class="my-0 secondary--text">
						{{ item.text }}
					</p>
				</v-breadcrumbs-item>
			</template>
		</v-breadcrumbs>
	</v-container>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";

export default {
	data:     () => ({ CrumbsLinkClass: "navigation-name pb-0 px-1 text-subtitle-2 font-weight-medium", }),
	computed: {

		/**
		 * @summary Retorna a rota corrente de navegação.
		 */
		currentRoute()
		{
			return this.$route.name;
		},

		/**
		 * @Summary Retorna o idioma corrente de navegação.
		 */
		currentRouteLanguageParam()
		{
			return this.$route.params.lang;
		},

		/**
		 * @Summary Retorna o elemento de monitoração corrente de navegação da turbina/unidade geradora.
		 */
		currentRouteMonitoringElementIdParam()
		{
			return parseInt(this.$route.params.monitoringElementId);
		},

		/**
		 * @Summary Retorna o elemento de monitoração corrente de navegação do parque/planta.
		 */
		currentRouteMonitoringElementParentIdParam()
		{
			return parseInt(this.$route.params.parentMonitoringElementId);
		},
		...mapState([ "WindPark", "WindTurbine", "ToolbarTreeMenuModule" ]),
	},
	methods: {

		/**
		 * @summary Retorna o conjunto de crumbs de navegação para a página/rota corrente.
		 * @returns {array} Itens de navegação.
		 */
		Crumbs()
		{
			// Este dicionário deve ter como chave o nome da rota definida em src/router/router.js.
			const crumbs = {
				Home:                             this.HomeCrumb(),
				Configurations:                   this.ConfigurationCrumb(),
				CompanyTrendLimitsConfiguration:  this.CompanyTrendLimitsConfigurationCrumb(),
				AlarmManagement:                  this.AlarmManagementCrumb(),
				FrequencyTrendLimitConfiguration: this.FrequencyTrendLimitConfigurationCrumb(),
				FrequencyTrendConfiguration:      this.FrequencyTrendConfigurationCrumb(),
				KinematicConfiguration:           this.BuildingParametersCrumb(),
				UserConfigurations:               this.UserConfigurationsCrumb(),
				Profile:                          this.ProfileCrumb(),
				WindHomeTrends:                   this.WindHomeTrendsCrumb(),
				WindPark:                         this.WindParkCrumb(),
				WindParkTrends:                   this.WindParkTrendsCrumb(),
				WindTurbine:                      this.WindTurbineCrumb(),
				WindTrends:                       this.WindTrendsCrumb(),
				WindRegisters:                    this.WindRegistersCrumb(),
				WindAudio:                        this.WindAudioCrumb(),
				WindOil:                          this.WindOilCrumb(),
				VDIWind:                          this.WindVDICrumb(),
				PitchAnalysis:                    this.WindPitchAnalysisCrumb(),
				WindDiagnosticSettings:           this.WindDiagnosticSettingsCrumb(),
				WindLimitsSettings:               this.WindLimitsSettingsCrumb(),
				HydroLimitsSettings:              this.HydroLimitsSettingsCrumb(),
				HydroElectricPowerPlant:          this.HydroElectricPowerPlantCrumb(),
				HydroElectricTurbine:             this.HydroElectricTurbineCrumb(),
				HydroTrends:                      this.HydroTrendsCrumb(),
				HydroRegisters:                   this.HydroRegistersCrumb(),
				HydroAudio:                       this.HydroAudioCrumb(),
				HydroEvents:                      this.HydroEventsCrumb(),
				VDIHydro:                         this.HydroVDICrumb(),
				AirGap:                           this.DiagnosticCrumb(),
				BladeDefect:                      this.DiagnosticCrumb(),
				PressureFluctuation:              this.DiagnosticCrumb(),
				OilWhirl:                         this.DiagnosticCrumb(),
				AngularMisalignment:              this.DiagnosticCrumb(),
				ParallelMisalignment:             this.DiagnosticCrumb(),
				Unbalance:                        this.DiagnosticCrumb(),
				Looseness:                        this.DiagnosticCrumb(),
				BearingPadsDefect:                this.DiagnosticCrumb(),
				StatorDefect:                     this.DiagnosticCrumb(),
				OverhungRotor:                    this.DiagnosticCrumb(),
				Rubbing:                          this.DiagnosticCrumb(),
				MagneticFlux:                     this.DiagnosticCrumb(),
				AnomalyDetection:                 this.AnomalyDetectionCrumb(),
			};

			return crumbs[this.currentRoute];
		},

		/**
		 * @summary Retorna os parâmetros da rota da turbina eólica para o parque eólico
		 * @returns {object} Parâmetros de retorno à página do parque eólico.
		 */
		FromWindTurbineToParkParams()
		{
			return {
				lang:                      this.currentRouteLanguageParam,
				parentMonitoringElementId: this.currentRouteMonitoringElementParentIdParam,
				monitoringElementId:       this.currentRouteMonitoringElementIdParam,
			};
		},

		/**
		 * @summary Retorna os parâmetros da rota da unidade geradora para a planta hidroelétrica.
		 * @returns {object} Parâmetros de retorno à página da planta hidroelétrica.
		 */
		FromHydroGeneratingUnitToPowerPlantParams()
		{
			return {
				lang:                      this.currentRouteLanguageParam,
				parentMonitoringElementId: this.currentRouteMonitoringElementParentIdParam,
				monitoringElementId:       this.currentRouteMonitoringElementIdParam,
			};
		},

		/**
		 * @summary Retorna os parâmetros da rota das páginas de análises à das unidades geradoras.
		 * @returns {object} Parâmetros de retorno à página das unidades geradoras.
		 */
		FromAnalysisPagesToGeneratingUnitParams()
		{
			return {
				lang:                      this.currentRouteLanguageParam,
				monitoringElementId:       this.currentRouteMonitoringElementIdParam,
				parentMonitoringElementId: this.currentRouteMonitoringElementParentIdParam
			};
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota Home.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		HomeCrumb()
		{
			return [ { text: i18n.t("Buttons.Home"), } ];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota WindHomeTrends.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		WindHomeTrendsCrumb()
		{
			return [
				{
					text:  i18n.t("Buttons.Home"), exact: true,
					to:    { name: "Home" },
				},
				{ text: i18n.t("Buttons.Trends"), },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota WindPark.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		WindParkCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{ text: i18n.t("Buttons.EolicPark"), },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota WindParkTrendsCrumb.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		WindParkTrendsCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{
					text:  i18n.t("Buttons.EolicPark"), exact: true,
					to:    { name: "WindPark", params: this.FromWindTurbineToParkParams(), }
				},
				{ text: i18n.t("Buttons.Trends"), },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota WindTurbine.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		WindTurbineCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{
					text:     i18n.t("Buttons.EolicPark"), disabled: false, exact:    true,
					to:       { name: "WindPark", params: this.FromWindTurbineToParkParams(), }
				},
				{ text: i18n.t("Buttons.WindTurbine") },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota WindTrends.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		WindTrendsCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{
					text:     i18n.t("Buttons.EolicPark"), disabled: false, exact:    true,
					to:       { name: "WindPark", params: this.FromWindTurbineToParkParams(), }
				},
				{
					text:     i18n.t("Buttons.WindTurbine"), disabled: false, exact:    true,
					to:       { name: "WindTurbine", params: this.FromAnalysisPagesToGeneratingUnitParams(), }
				},
				{ text: i18n.t("Buttons.Trends"), },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota WindRegisters.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		WindRegistersCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{
					text:     i18n.t("Buttons.EolicPark"), disabled: false, exact:    true,
					to:       { name: "WindPark", params: this.FromWindTurbineToParkParams(), }
				},
				{
					text:     i18n.t("Buttons.WindTurbine"), disabled: false, exact:    true,
					to:       { name: "WindTurbine", params: this.FromAnalysisPagesToGeneratingUnitParams(), }
				},
				{ text: i18n.t("Buttons.SignalRegisters"), },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota WindAudio.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		WindAudioCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{
					text:     i18n.t("Buttons.EolicPark"), disabled: false, exact:    true,
					to:       { name: "WindPark", params: this.FromWindTurbineToParkParams(), }
				},
				{
					text:     i18n.t("Buttons.WindTurbine"), disabled: false, exact:    true,
					to:       { name: "WindTurbine", params: this.FromAnalysisPagesToGeneratingUnitParams(), }
				},
				{ text: i18n.t("Buttons.Audio"), },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota WindOil.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		WindOilCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{
					text:     i18n.t("Buttons.EolicPark"), disabled: false, exact:    true,
					to:       { name: "WindPark", params: this.FromWindTurbineToParkParams(), }
				},
				{
					text:     i18n.t("Buttons.WindTurbine"), disabled: false, exact:    true,
					to:       { name: "WindTurbine", params: this.FromAnalysisPagesToGeneratingUnitParams(), }
				},
				{ text: i18n.t("Titles.WindOilDegradation"), },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota VDIWind.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		WindVDICrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{
					text:     i18n.t("Buttons.EolicPark"), disabled: false, exact:    true,
					to:       { name: "WindPark", params: this.FromWindTurbineToParkParams(), }
				},
				{
					text:     i18n.t("Buttons.WindTurbine"), disabled: false, exact:    true,
					to:       { name: "WindTurbine", params: this.FromAnalysisPagesToGeneratingUnitParams(), }
				},
				{ text: i18n.t("Labels.VDI"), },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota PitchAnalysis.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		WindPitchAnalysisCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{
					text:     i18n.t("Buttons.EolicPark"), disabled: false, exact:    true,
					to:       { name: "WindPark", params: this.FromWindTurbineToParkParams(), }
				},
				{
					text:     i18n.t("Buttons.WindTurbine"), disabled: false, exact:    true,
					to:       { name: "WindTurbine", params: this.FromAnalysisPagesToGeneratingUnitParams(), }
				},
				{ text: i18n.t("Titles.PitchBearing") },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota WindDiagnosticSettings.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		WindDiagnosticSettingsCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{
					text:     i18n.t("Buttons.EolicPark"), disabled: false, exact:    true,
					to:       { name: "WindPark", params: this.FromWindTurbineToParkParams(), }
				},
				{
					text:     i18n.t("Buttons.WindTurbine"), disabled: false, exact:    true,
					to:       { name: "WindTurbine", params: this.FromAnalysisPagesToGeneratingUnitParams(), }
				},
				{ text: i18n.t("Titles.DiagnosticConfigurator"), },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota LimitsSettings em Wind.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		WindLimitsSettingsCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{
					text:     i18n.t("Buttons.EolicPark"), disabled: false, exact:    true,
					to:       { name: "WindPark", params: this.FromWindTurbineToParkParams(), }
				},
				{
					text:     i18n.t("Buttons.WindTurbine"), disabled: false, exact:    true,
					to:       { name: "WindTurbine", params: this.FromAnalysisPagesToGeneratingUnitParams(), }
				},
				{ text: i18n.t("Titles.SignalConfigurator"), },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota LimitsSettings em Hydro.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		HydroLimitsSettingsCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{
					text:     i18n.t("Buttons.HydroPowerPlant"), disabled: false, exact:    true,
					to:       { name: "HydroElectricPowerPlant", params: this.FromHydroGeneratingUnitToPowerPlantParams(), }
				},
				{
					text:     i18n.t("Buttons.GeneratingUnit"), disabled: false, exact:    true,
					to:       { name: "HydroElectricTurbine", params: this.FromAnalysisPagesToGeneratingUnitParams(), }
				},
				{ text: i18n.t("Titles.SignalConfigurator"), },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota HydroElectricPowerPlant.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		HydroElectricPowerPlantCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{ text: i18n.t("Buttons.HydroPowerPlant"), },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota HydroElectricTurbine.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		HydroElectricTurbineCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{
					text:     i18n.t("Buttons.HydroPowerPlant"), disabled: false, exact:    true,
					to:       { name: "HydroElectricPowerPlant", params: this.FromHydroGeneratingUnitToPowerPlantParams(), }
				},
				{ text: i18n.t("Buttons.GeneratingUnit"), },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota HydroTrends.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		HydroTrendsCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{
					text:     i18n.t("Buttons.HydroPowerPlant"), disabled: false, exact:    true,
					to:       { name: "HydroElectricPowerPlant", params: this.FromHydroGeneratingUnitToPowerPlantParams(), }
				},
				{
					text:     i18n.t("Buttons.GeneratingUnit"), disabled: false, exact:    true,
					to:       { name: "HydroElectricTurbine", params: this.FromAnalysisPagesToGeneratingUnitParams(), }
				},
				{ text: i18n.t("Buttons.Trends"), },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota HydroRegisters.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		HydroRegistersCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{
					text:     i18n.t("Buttons.HydroPowerPlant"), disabled: false, exact:    true,
					to:       { name: "HydroElectricPowerPlant", params: this.FromHydroGeneratingUnitToPowerPlantParams(), }
				},
				{
					text:     i18n.t("Buttons.GeneratingUnit"), disabled: false, exact:    true,
					to:       { name: "HydroElectricTurbine", params: this.FromAnalysisPagesToGeneratingUnitParams(), }
				},
				{ text: i18n.t("Buttons.SignalRegisters"), },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota HydroAudio.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		HydroAudioCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{
					text:     i18n.t("Buttons.HydroPowerPlant"), disabled: false, exact:    true,
					to:       { name: "HydroElectricPowerPlant", params: this.FromHydroGeneratingUnitToPowerPlantParams(), }
				},
				{
					text:     i18n.t("Buttons.GeneratingUnit"), disabled: false, exact:    true,
					to:       { name: "HydroElectricTurbine", params: this.FromAnalysisPagesToGeneratingUnitParams(), }
				},
				{ text: i18n.t("Buttons.Audio"), },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota HydroEvents.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		HydroEventsCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{
					text:     i18n.t("Buttons.HydroPowerPlant"), disabled: false, exact:    true,
					to:       { name: "HydroElectricPowerPlant", params: this.FromHydroGeneratingUnitToPowerPlantParams(), }
				},
				{
					text:     i18n.t("Buttons.GeneratingUnit"), disabled: false, exact:    true,
					to:       { name: "HydroElectricTurbine", params: this.FromAnalysisPagesToGeneratingUnitParams(), }
				},
				{ text: i18n.t("Buttons.Events"), },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota AirGap.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		DiagnosticCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{
					text:     i18n.t("Buttons.HydroPowerPlant"), disabled: false, exact:    true,
					to:       { name: "HydroElectricPowerPlant", params: this.FromHydroGeneratingUnitToPowerPlantParams(), }
				},
				{
					text:     i18n.t("Buttons.GeneratingUnit"), disabled: false, exact:    true,
					to:       { name: "HydroElectricTurbine", params: this.FromAnalysisPagesToGeneratingUnitParams(), }
				},
				{ text: i18n.t("Titles.Diagnostics"), },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota VDIHydro.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		HydroVDICrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{
					text:     i18n.t("Buttons.HydroPowerPlant"), disabled: false, exact:    true,
					to:       { name: "HydroElectricPowerPlant", params: this.FromHydroGeneratingUnitToPowerPlantParams(), }
				},
				{
					text:     i18n.t("Buttons.GeneratingUnit"), disabled: false, exact:    true,
					to:       { name: "HydroElectricTurbine", params: this.FromAnalysisPagesToGeneratingUnitParams(), }
				},
				{ text: i18n.t("Labels.VDI"), },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota AnomalyDetection.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		AnomalyDetectionCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{
					text:     i18n.t("Buttons.HydroPowerPlant"), disabled: false, exact:    true,
					to:       { name: "HydroElectricPowerPlant", params: this.FromHydroGeneratingUnitToPowerPlantParams(), }
				},
				{
					text:     i18n.t("Buttons.GeneratingUnit"), disabled: false, exact:    true,
					to:       { name: "HydroElectricTurbine", params: this.FromAnalysisPagesToGeneratingUnitParams(), }
				},
				{ text: i18n.t("Buttons.Anomaly"), },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota Configuration.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		ConfigurationCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{ text: i18n.t("Titles.Settings"), },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota CompanyTrendLimitsConfiguration.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		CompanyTrendLimitsConfigurationCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{
					text:     i18n.t("Titles.Settings"), disabled: false, exact:    true,
					to:       { name: "Configurations", params: { lang: this.currentRouteLanguageParam, }, }
				},
				{ text: i18n.t("Titles.GlobalLimitsAndNotifications"), },
			];
		},

		/**
		 * Retorna o conjunto de navegação da rota AlarmManagement.
		 * @returns {array} Itens de navegação disponível para a rota.
		*/
		AlarmManagementCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" } },
				{ text: i18n.t("Titles.AlarmManagement") },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota FrequencyTrendLimitConfiguration.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		FrequencyTrendLimitConfigurationCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{
					text:     i18n.t("Titles.Settings"), disabled: false, exact:    true,
					to:       { name: "Configurations", params: { lang: this.currentRouteLanguageParam, }, }
				},
				{ text: i18n.t("Titles.FrequencyLimitsAndNotifications"), },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota CompanyTrendLimitsConfiguration.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		FrequencyTrendConfigurationCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{
					text:     i18n.t("Titles.Settings"), disabled: false, exact:    true,
					to:       { name: "Configurations", params: { lang: this.currentRouteLanguageParam, }, }
				},
				{ text: i18n.t("Titles.TrendFrequencyComponent") },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota BuildingParameters.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		BuildingParametersCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{
					text:     i18n.t("Titles.Settings"), disabled: false, exact:    true,
					to:       { name: "Configurations", params: { lang: this.currentRouteLanguageParam, }, }
				},
				{ text: i18n.t("Titles.KinematicParameters"), },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota UserConfigurations.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		UserConfigurationsCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{
					text:     i18n.t("Titles.Settings"), disabled: false, exact:    true,
					to:       { name: "Configurations", params: { lang: this.currentRouteLanguageParam, }, }
				},
				{ text: i18n.t("Labels.Users"), },
			];
		},

		/**
		 * @summary Retorna o conjunto de navegação da rota Profile.
		 * @returns {array} Itens de navegação disponível para a rota.
		 */
		ProfileCrumb()
		{
			return [
				{ text: i18n.t("Buttons.Home"), to: { name: "Home" }, },
				{ text: i18n.t("Buttons.Profile"), },
			];
		}
	},
};
</script>
